import { call, put } from 'redux-saga/effects';
import { BuyersAsyncActions } from 'store/actions/buyers';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* createBuyerProfile(action) {
  const {
    CreateBuyerProfile: {
      Actions: { SUCCESS, FAILURE },
    },
  } = BuyersAsyncActions;

  const {
    payload: { buyerProfile },
  } = action;

  try {
    const response = yield call(apiCall, '/buyerProfiles', 'post', buyerProfile);
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default createBuyerProfile;
